import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const CTA_ROUTES = [
  '/',
  '/login',
  '/login/password',
  '/reset-password',
  '/onboarding/name',
  '/onboarding/birth',
  '/onboarding/interests',
  '/onboarding/looking-for',
  '/onboarding/reading',
  '/onboarding/teaser',
  '/onboarding/photos',
  '/onboarding/email',
  '/onboarding/password/new',
  '/onboarding/password/existing',
  '/onboarding/final'
]

/**
 * Устанавливает CSS-переменную --cta-bottom так, чтобы фиксированная кнопка CTA
 * (Continue / Save) оставалась над клавиатурой на мобильных при открытом вводе.
 */
export default function VisualViewportCTA() {
  const location = useLocation()
  const isCTAPage = CTA_ROUTES.includes(location.pathname)

  useEffect(() => {
    if (!isCTAPage) return

    const update = () => {
      const v = window.visualViewport
      if (!v) return
      const keyboardOffset = window.innerHeight - v.height
      const bottom = keyboardOffset > 0 ? keyboardOffset + 16 : 16
      document.documentElement.style.setProperty('--cta-bottom', `${Math.max(16, bottom)}px`)
    }

    update()
    const v = window.visualViewport
    if (v) {
      v.addEventListener('resize', update)
      v.addEventListener('scroll', update)
      return () => {
        v.removeEventListener('resize', update)
        v.removeEventListener('scroll', update)
        document.documentElement.style.removeProperty('--cta-bottom')
      }
    }
  }, [isCTAPage])

  return null
}
